/**
 * Composable for i18n usage in components
 */
import { useI18n as useVueI18n } from 'vue-i18n'
import { i18n, setLocale } from '@/common/i18n'

export const tGlobal = i18n.global.t

export function useI18n() {
  const { t, locale } = useVueI18n()

  return {
    t,
    locale,
    setLocale,
  }
}

